<template>
  <div class="container masonry-youtube" id="masonry-youtube">
    <div class="columns is-gapless is-centered">
      <div class="column is-10">
        <h1 class="title" v-if="false">
          Videos
        </h1>
        <div class="masonry-container" id="masonry-container" v-masonry transition-duration="0.0s" item-selector=".masonry-item" data-masonry-options="{ 'isFitWidth': true }" v-infinite-scroll="loadMore" infinite-scroll-disabled="itemsLoading" infinite-scroll-distance="10">

          <div v-masonry-tile class="masonry-item" v-for="(item, index) in items" data-aos="slide-up" data-aos-once="true" data-aos-duration="1000" data-aos-offset="0">
            <!-- block item markup
            <img :src="image.image_900" class="img-responsive" style="width:100%;" /> -->
            <a :href="'http://www.youtube.com/watch?v='+item.snippet.resourceId.videoId" target="_blank">
              <div class="card">
                <div class="card-image">
                  <figure class="image" style="position:relative;">
                    <img :src="parseInstagramImageLink(item.snippet.thumbnails.high.url)" alt="Image">
                    <!-- <img :src="item.images.thumbnail.url" alt="Image"> -->
                    <div class="card-image-cover">
                      <i class="fa fa-4x fa-play"></i>
                      <div class="card-image-cover-description">
                        {{ item.snippet.title }}
                      </div>
                    </div>
                  </figure>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div class="load-more">
          <div class="button" v-if="!itemsEnded" @click="loadMore()" :class="{ 'is-loading': itemsLoading }"></div>
          <div class="ended" v-if="itemsEnded" data-aos="slide-up" data-aos-once="true" data-aos-duration="1000">More videos:<br class="is-hidden-desktop" />&nbsp;&nbsp;<a  :href="navYoutube.path" target="_blank"><i class="fa fa-2x fa-youtube" style="vertical-align:middle;"></i> / {{ navYoutube.title }}</a></div>
        </div>

        <div class="control notification is-danger" v-if="error">
          <button class="delete" @click="error = undefined"></button>
          {{ error }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/Site'
// import Instafetch from '@/controllers/Instafetch'

export default {
  name: 'masonry-youtube',
  components: {
  },
  data () {
    return {
      isDesktop: true,
      itemsCache: [],
      items: [],
      itemsLoading: false,
      itemsEnded: false,
      itemsHasNext: false,
      itemsHasNextToken: undefined,
      itemsMax: 48,
      error: undefined,
      navYoutube: EventBus._data._navYoutube
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    // refresh masonry
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    parseInstagramImageLink (link) {
      var linkOut = link.replace(/(https*:\/\/.*\/.*)\/.*\/.*\/.*(\/.*)/g, '$1$2')
      return linkOut
    },
    getItems: function (onComplete) {
      this.itemsLoading = true
      this.error = undefined
      // Youtube.authenticate({
      //   type: 'key',
      //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
      // })
      // var params = {
      //   term: 'search',
      //   part: 'snippet',
      //   channelId: 'UCLXo7UDZvByw2ixzpQCufnA',
      //   order: 'date',
      //   type: 'video',
      //   videoSyndicated: true,
      //   maxResults: 50,
      //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
      // }
      // apis.get('https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCLXo7UDZvByw2ixzpQCufnA&order=date&type=video&videoSyndicated=true&maxResults=50&key=AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM')
      var params = {
        term: 'playlistItems',
        part: 'snippet',
        playlistId: 'UUy4ssRxw_k0XdiH31OxVHmA',
        maxResults: 12,
        key: 'AIzaSyB0p_sU61SfOC0Pe2-I-gBZl8ebk6xaeJw'
      }
      Site.youtube(params.term, params)
        .then((data) => {
          // console.log('Youtube Response')
          // console.log(data)
          this.itemsHasNext = false
          this.itemsHasNextToken = undefined
          onComplete(data.items)
          this.itemsEnded = true
          this.$emit('onItemsEnded', {})
          this.itemsLoading = false
        })
        .catch((error) => {
          console.log('Youtube Error')
          console.log(error)
          this.itemsHasNext = false
          this.itemsHasNextToken = undefined
          this.items = []
          this.error = error.error
          this.error = 'Unable to load, please kindly visit our Youtube account <a href="' + this.navYoutube.path + '" target="_blank">here</a>.'
          this.itemsEnded = true
          this.$emit('onItemsEnded', {})
          this.itemsLoading = false
        })
    },
    refresh: function () {
      this.getItems((items) => {
        this.items = items
      })
    },
    loadMore: function () {
      // return if exceed (showcase purpose)
      // if (!this.itemsHasNext) {
      //   this.itemsEnded = true
      //   this.$emit('onItemsEnded', {})
      //   return
      // }
      //
      // if (!this.itemsEnded) {
      //   this.getItems(function (items) {
      //     this.items = this.items.concat(items)
      //     if (this.items.length > this.itemsMax) {
      //       this.items = this.items.slice(0, this.itemsMax)
      //       this.itemsEnded = true
      //       this.$emit('onItemsEnded', {})
      //     }
      //   }.bind(this))
      // }
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// main gallery

.masonry-youtube {
  min-height: 800px;
  margin-top: 70px;
  padding: 15px;
  padding-top: 30px;
  padding-bottom: 80px;
  padding-right: 0px;

  @media screen and (min-width: $desktop) {
    padding: 0px;
    padding-top: 30px;
    padding-bottom: 80px;
  }

  .title {
    padding-left: 0px;

    @media screen and (min-width: $desktop) {
      padding-left: 10px;
    }
  }
}

.lb-image {
  width: auto !important
}

.masonry-container {
  margin: 0 auto;
}

.masonry-item {
  margin: 0 auto 0 auto;
  padding: 0px;
  padding-left: 0px;
  padding-right: 15px;
  padding-bottom: 15px;
  width: 50%;

  @media screen and (min-width: $desktop) {
    padding-left: 10px;
    padding-right: 10px;
  }

  @media screen and (min-width: $tablet) {
    width: 33.33%;
  }

  @media screen and (min-width: $desktop) {
    width: 33.33%;
  }

  .card {
    border-radius: 0px;
    box-shadow: 0 0 0, 0 0 0 0;
    overflow: hidden;

    .card-header, .card-image {
      img {
        border-radius: 0px;
        transition: all 1s ease;

        // &:hover {
        //   transform: scale(1.2);
        // }
      }

      .card-image-cover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        display: flex;
        transition: all 0.5s ease;

        &:hover {
          opacity: 1;
          background-color: rgba(0,0,0,0.5);
        }

        i.fa {
          color: $color-gray-light;
          margin: auto;
        }

        .card-image-cover-description {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 10px;
          color: white;
          font-size: 0.8em;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .card-content {
      display: none;
    }
  }
}

.load-more {
  margin-top: 50px;
  padding-left: 15px;
  padding-right: 15px;
  text-align: right;

  .button, .ended {
    margin: 0 auto;
    border: 0px;
    background-color: transparent;
    color: #999999;

    a {
      color: $color-gray;

      &:hover {
        color: $color-gray-mid;
      }
    }

    &.is-loading:after {
      border-color: #999999;
      border-right-color: transparent;
      border-top-color: transparent;
    }
  }
}

</style>



// WEBPACK FOOTER //
// MasonryYoutube.vue?2f10bd53